/**
 * Created by olga on 27.09.2024
 */

const FixableView = cc.Node.extend({
    ctor: function (component, unitView) {
        this._super();

        this.unitView = unitView;
    },

    afterUpgradeStage: function (f) {
        const previousStageImage = cleverapps.persist.acceptNode("PreviousStageImage");
        if (!this.unitView.sprite.isVisible()) {
            previousStageImage.removeFromParent();
            f();
            return;
        }

        if (this.unitView.sprite.hasAnimation("change")) {
            previousStageImage.removeFromParent();
            this.unitView.sprite.setAnimationAndIdleAfter("change", "animation");
            this.unitView.sprite.setCompleteListenerOnce(f);
        } else {
            f = cleverapps.wait(2, f);
            previousStageImage.setVisible(true);
            previousStageImage.runAction(UnitView.runUpgradeAnimation(previousStageImage, this.unitView)).setFinalize(f);
            this.unitView.addUpgradeAnimation(f);
        }
    }
});